module.exports = __webpack_public_path__ + "static/zm-0c05257970d1a63c4177460f14ba37c6.svg";